import { JsonPipe } from '@angular/common'
import { Component, EventEmitter, Input, Output, inject, input, signal } from '@angular/core'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { NgbActiveModal, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap'
import { AirQuoteService } from 'projects/quoting-app/src/app/services/air-quote.service'
import { InputComponent } from 'projects/quoting-app/src/app/shared/components/form/input/input.component'
import { RequestCallbackForm } from './request-callback-form.interface'
import { FloatingLabelInputComponent } from 'projects/quoting-app/src/app/shared/components/form/floating-label-input/floating-label-input.component'
import { AirQuoteCustomer } from 'projects/quoting-app/src/app/shared/interfaces/air-quote-customer.interface'
import { FloatingLabelPostcodeInputComponent } from 'projects/quoting-app/src/app/shared/components/form/floating-label-postcode-input/floating-label-postcode-input.component'
import { ToggleComponent } from 'projects/quoting-app/src/app/shared/components/form/toggle/toggle.component'

@Component({
    selector: 'sf-request-callback-modal',
    imports: [
        ReactiveFormsModule,
        NgbAlertModule,
        InputComponent,
        FloatingLabelInputComponent,
        FloatingLabelPostcodeInputComponent,
        ToggleComponent,
        JsonPipe,
    ],
    templateUrl: './request-callback-modal.component.html',
    styleUrl: './request-callback-modal.component.scss',
})
export class RequestCallbackModalComponent {
    activeModal = inject(NgbActiveModal)
    #fb = inject(FormBuilder)
    #airQuoteService = inject(AirQuoteService)

    error = signal<string | null>(null)

    quoteId = input.required<string>()

    @Input({ required: true })
    set selectedPackId(value: number) {
        this.form.controls.packId.setValue(value)
    }

    @Input()
    set customer(value: AirQuoteCustomer | null) {
        if (!value) return
        this.form.patchValue(value)
    }

    @Output()
    callbackRequestCompleted = new EventEmitter<void>()

    form = this.#fb.group<RequestCallbackForm>({
        firstName: this.#fb.nonNullable.control<string>('', [Validators.required, Validators.maxLength(50)]),
        lastName: this.#fb.nonNullable.control<string>('', [Validators.required, Validators.maxLength(50)]),
        postcode: this.#fb.nonNullable.control<string>('', [Validators.required, Validators.maxLength(10)]),
        phone: this.#fb.nonNullable.control<string>('', [Validators.required, Validators.maxLength(15)]),
        emailAddress: this.#fb.nonNullable.control<string>('', [Validators.required, Validators.email]),
        packId: this.#fb.nonNullable.control<number | null>(0),
        confirmed: this.#fb.nonNullable.control<boolean>(false, [Validators.requiredTrue]),
    })

    submit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched()
            return
        }

        this.#airQuoteService.submitCallbackRequest(this.quoteId(), this.form.getRawValue()).subscribe({
            next: () => {
                this.callbackRequestCompleted.emit()
                this.activeModal.close(this.form.value)
            },
            error: () => {
                this.error.update(() => 'An error occurred while submitting the request. Please try again.')
            },
        })
    }
}
